export default "__VITE_ASSET__BlLe3EzR__"